import { Alert, AlertDescription, AlertIcon, Link, Stack } from '@chakra-ui/react'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams, Link as NavLink } from 'react-router-dom'

import { ssoLogin } from '../../redux/storeConfig/slices/slice.auth'
import LoadingSpinner from '../general/LoadingSpinner'

export default function SSoSignInPage() {
  /** @type {import('../../redux/storeConfig/slices/slice.auth/auth.types').AuthSlice} */
  const { errors } = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const { sso_id, sso_token } = useParams()
  const history = useHistory()

  const [alert, setAlert] = useState(false)

  const authenticateAdmin = useCallback(async () => {
    try {
      await dispatch(ssoLogin(sso_id, sso_token))

      history.push('/')
    } catch (err) {
      setAlert(true)
    }
  }, [dispatch, history, sso_id, sso_token])

  useEffect(() => {
    authenticateAdmin()
  }, [authenticateAdmin])

  if (alert)
    return (
      <Stack spacing="6">
        <Alert status="error">
          <AlertIcon />
          <AlertDescription>{errors[0]?.message ?? 'An error occurred while logging in.'}</AlertDescription>
        </Alert>
        <Link as={NavLink} to="/login">
          Return to Sign In
        </Link>
      </Stack>
    )
  return (
    <div>
      <LoadingSpinner />
    </div>
  )
}

export { SSoSignInPage }
